export default "__VITE_ASSET__BAPmNE4Y__"